import { Injectable } from "@angular/core";

import { AppCore } from "app/app.core";

@Injectable()
export class TimerService extends AppCore {

    private count: number = 0;
    private seconds: number = 0;
    private minutes: number = 0;
    private hours: number = 0;
    public displayTime: string = '00:00:00';

    private timeRef: any = null;
    private eventId: number = 0;

    public active: boolean = false;

    constructor() {
        super();
    }

    public initTimer(seconds: number = 0): this {
        this.seconds = 0;
        this.minutes = Math.floor(seconds / 60) + Math.round(seconds % 60 / 60);
        this.hours = Math.floor(this.minutes / 60);

        if (this.minutes % 60 == 0) {
            this.minutes = 0;
        } else if (this.minutes % 60 > 0) {
            this.minutes = this.minutes % 60;
        }
        this.count = ((this.hours * 60) * 60) + (this.minutes * 60);
        return this;
    }

    public setEventID(id: number): this {
        this.eventId = id;
        return this;
    }

    public getEventID(): number {
        return this.eventId;
    }

    public getSeconds(): number {
        return this.count;
    }

    public getHours(): number {
        return this.hours;
    }

    public getMinutes(): number {
        return this.minutes;
    }

    public getTime(): string {
        this.reloadShowTime();
        return this.displayTime;
    }

    public startCount(): this {
        this.active = true;
        clearInterval(this.timeRef);
        this.timeRef = setInterval(() => {
            this.count++;
            this.seconds++;
            if (this.seconds >= 60) {
                this.minutes++;
                if (this.minutes >= 60) {
                    this.hours++;
                    this.minutes = 0;
                    this.seconds = 0;
                }
                this.seconds = 0;
            }
            this.reloadShowTime();
        }, 1000);
        return this;
    }

    public pauseCount(): void {
        this.active = false;
        clearInterval(this.timeRef);
    }

    public addMinutes(minutes: number = 10): void {
        this.minutes = this.minutes + minutes;
        if (this.minutes >= 60) {
            this.hours++;
            let resto = this.minutes % 60;
            this.minutes = resto;
        }
        this.count = this.count + (minutes / 60);
    }

    public subtractMinutes(minutes: number = 10): void {
        this.minutes = this.minutes - minutes;
        if (this.minutes < 0) {
            this.hours--;
            this.minutes = 60 + this.minutes;
        }
        this.count = this.count - (minutes / 60);
    }

    public saveSeconds(): void {
        let timers = this.getLocalItem('activeTimers') || {};
        timers[this.eventId] = this.count;
        this.persis('activeTimers', timers);
    }

    public reloadShowTime(): void {
        let hours: string = ('0' + this.hours).substr(-2);
        let minutes: string = ('0' + this.minutes).substr(-2);
        let seconds: string = ('0' + this.seconds).substr(-2);
        this.displayTime = `${hours}:${minutes}:${seconds}`;
    }

    public destroy(save: boolean = false): void {
        this.active = false;
        this.eventId = 0;
        this.initTimer().reloadShowTime();
        if (this.timeRef) {
            clearInterval(this.timeRef);
        }
        if (save) {
            this.saveSeconds();
        }
    }
}


// WEBPACK FOOTER //
// ./src/app/services/funcional/timer.service.ts